import { createRouter, createWebHistory } from 'vue-router';
import { useSessionStore } from '@/store';

const routes = [
  {
    path: '/',
    name: 'home-layout',
    component: () => import('@/views/HomeLayout.vue'),
    children: [
      {
        path: '',
        name: 'dashboard',
        meta: { requiresAuth: true },
        component: () => import('@/views/Dashboard.vue'),
      },
      {
        path: '/alerts',
        name: 'alerts',
        meta: { requiresAuth: true },
        component: () => import('@/views/Alerts.vue'),
      },
      {
        path: '/residents',
        name: 'residents',
        meta: { requiresAuth: true },
        component: () => import('@/views/Residents.vue'),
      },
      {
        path: '/residents/:id',
        name: 'resident-details',
        meta: { requiresAuth: true },
        component: () => import('@/views/ResidentDetails.vue'),
      },
    ],
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login.vue'),
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('@/views/ForgotPassword.vue'),
  },
  {
    path: '/invitation/:id',
    name: 'invitation',
    component: () => import('@/views/Invitation.vue'),
  },
  {
    path: '/invitation-accepted',
    name: 'invitation-accepted',
    component: () => import('@/views/InvitationAccepted.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    name: '404',
    component: () => import('@/views/404.vue'),
  },

];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach(async (to) => {
  const session = useSessionStore();
  const hostname = window.location.hostname;
  if (to.meta.requiresAuth) {
    if (!session.user && !hostname.startsWith('connect.')) {
      return {
        path: '/login',
        query: { redirect: to.fullPath },
      };
    }
  }
});

export default router;
